import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import {
  FaEye, FaBullseye, FaChild, FaUsers, FaStar, FaPrayingHands, FaRegClock,
  FaMapMarkerAlt, FaArrowRight, FaChevronDown,
  FaClipboardList, FaVideo, FaChartLine, FaHeadphones, FaShieldAlt,
  FaMusic, FaHandsHelping, FaUserFriends, FaCrown, FaFire, FaGraduationCap,
} from 'react-icons/fa';
import './AboutUs.css';
import Footer from '../Footer';

import heroImg from '../../Assets/dance.jpg';
import storyImg from '../../Assets/Smile.jpg';
import Img1 from '../../Assets/Muta.jpg';
import Img2 from '../../Assets/Onezz.jpg';
import Img3 from '../../Assets/AJ.jpeg';
import Img4 from '../../Assets/Kira.webp';
import Img5 from '../../Assets/deeeric.jpeg';
import Img6 from '../../Assets/Marthaa.jpeg';
import Img10 from '../../Assets/Malobaz.jpg';
import Img13 from '../../Assets/Kidahaz.jpg';
import Img15 from '../../Assets/Masikas.jpg';

const VALUES = [
  {
    letter: 'S',
    icon: <FaChild aria-hidden="true" />,
    title: 'Sonship',
    desc: 'Walking in our true identity as beloved sons and daughters of God, living from secure acceptance and divine authority.',
  },
  {
    letter: 'T',
    icon: <FaUsers aria-hidden="true" />,
    title: 'Teamwork',
    desc: 'Collaborating selflessly across every ministry and campus to achieve greater kingdom impact together.',
  },
  {
    letter: 'E',
    icon: <FaStar aria-hidden="true" />,
    title: 'Excellence',
    desc: 'Pursuing the highest biblical standards and honor in all we do as an offering of heartfelt devotion unto God.',
  },
  {
    letter: 'P',
    icon: <FaPrayingHands aria-hidden="true" />,
    title: 'Prayer',
    desc: 'Prioritizing communion with God as our engine, seeking His heart, presence and guidance in all things.',
  },
  {
    letter: 'P',
    icon: <FaRegClock aria-hidden="true" />,
    title: 'Punctuality',
    desc: 'Honoring God and valuing others through faithfulness, respect, preparation, and timely stewardship.',
  },
];

const JOURNEY = [
  { n: '01', title: 'Come', desc: 'Arrive just as you are and feel genuinely welcome from the very first moment.' },
  { n: '02', title: 'Grow', desc: 'Stay, put down roots, and keep growing in faith through community and teaching.' },
  { n: '03', title: 'Go', desc: 'Be sent out to reach your family, your city and your world in Jesus’ name.' },
];

const LEADERSHIP = [
  { name: 'Ps. Alex & Faith Mutagubya', title: 'Lead Pastors, The City Churches', avatar: Img1 },
  { name: 'Pastor Judith', title: 'Executive Pastor, The City Churches', avatar: Img3 },
  { name: 'Ps. Dennis & Becky Onen', title: 'Youth Pastors, The City Churches', avatar: Img2 },
  { name: 'Ps. Lillian & Simon Kirabo', title: 'Location Pastors, Iganga', avatar: Img4 },
  { name: 'Ps. Derrick & Deborah Mooli', title: 'Location Pastors, Kirinya', avatar: Img5 },
  { name: 'Pastor Martha Banalya', title: 'Location Pastor, Luzira', avatar: Img6 },
];

const ELDERS = [
  { name: 'Mr & Mrs. Masika', avatar: Img15 },
  { name: 'Mr & Mrs. Kidaha', avatar: Img13 },
  { name: 'Mr & Mrs. Maloba', avatar: Img10 },
];

const MINISTRIES = [
  {
    name: 'Administration',
    head: 'Alex Namonye',
    description: 'Overseeing church operations, records and day-to-day coordination.',
    icon: <FaClipboardList aria-hidden="true" />,
  },
  {
    name: 'Media Team',
    head: 'Omoding Marvin',
    description: 'Handling all media and communication needs.',
    icon: <FaVideo aria-hidden="true" />,
  },
  {
    name: 'Fit For Life',
    head: 'Mrs. Rebecca Baguma',
    description: 'Building training and financial literacy among members.',
    icon: <FaChartLine aria-hidden="true" />,
  },
  {
    name: 'Sound Team',
    head: 'Mr. Aijuka',
    description: 'Managing audio for services and events.',
    icon: <FaHeadphones aria-hidden="true" />,
  },
  {
    name: 'Children Ministry',
    head: 'Mrs. Lydia Biira',
    description: 'Nurturing the faith of our children.',
    icon: <FaChild aria-hidden="true" />,
  },
  {
    name: "King's Men Ministry",
    head: 'Mr. Bwenje Caleb',
    description: 'Empowering the men of the church.',
    icon: <FaShieldAlt aria-hidden="true" />,
  },
  {
    name: 'Tusinze Band',
    head: 'Mr. Ronald Simbwa',
    description: 'Leading worship and music ministry.',
    icon: <FaMusic aria-hidden="true" />,
  },
  {
    name: 'Care Ministry',
    head: 'Mr & Mrs. Maloba',
    description: 'Providing care and support to the congregation.',
    icon: <FaHandsHelping aria-hidden="true" />,
  },
  {
    name: 'First Impressions',
    head: 'Miss Yvonne Tumwine',
    description: 'Welcoming and assisting newcomers.',
    icon: <FaUserFriends aria-hidden="true" />,
  },
  {
    name: 'Royal Women Ministry',
    head: 'Mrs. Masika Victoria',
    description: 'Empowering women to greatness.',
    icon: <FaCrown aria-hidden="true" />,
  },
  {
    name: 'The Christ Generation',
    head: 'Belinda & Shamillah',
    description: 'Raising a generation of young people to know Christ and make Him known.',
    icon: <FaFire aria-hidden="true" />,
  },
  {
    name: 'Awake Campus Move',
    head: 'Kevin Ssimbwa',
    description: 'Reaching and discipling students to live awake for Christ across campuses.',
    icon: <FaGraduationCap aria-hidden="true" />,
  },
];

function useReveal() {
  const ref = useRef(null);
  useEffect(() => {
    const root = ref.current;
    if (!root) return undefined;
    const els = root.querySelectorAll('.reveal');
    if (!('IntersectionObserver' in window)) {
      els.forEach((el) => el.classList.add('is-visible'));
      return undefined;
    }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) { e.target.classList.add('is-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => io.observe(el));
    return () => io.disconnect();
  }, []);
  return ref;
}

function AboutUs() {
  const ref = useReveal();

  return (
    <div ref={ref}>
      {/* HERO */}
      <header className="ab-hero">
        <img src={heroImg} alt="" className="ab-hero__bg" />
        <div className="ab-hero__scrim" aria-hidden="true" />
        <div className="tcc-container ab-hero__inner">
          <p className="tcc-eyebrow ab-hero__eyebrow">Our Story</p>
          <h1 className="ab-hero__title">A beacon of hope,<br />transforming lives across Uganda</h1>
          <p className="ab-hero__lead">
            From a single congregation in Luzira to a family of campuses across the
            nation. This is the story of God at work through ordinary people.
          </p>
          <dl className="ab-stats">
            <div className="ab-stat"><dt>Campuses</dt><dd>3</dd></div>
            <div className="ab-stat"><dt>Ministries</dt><dd>{MINISTRIES.length}</dd></div>
            <div className="ab-stat"><dt>Core Values</dt><dd>{VALUES.length}</dd></div>
          </dl>
        </div>
        <a className="ab-hero__scroll" href="#ab-story" aria-label="Scroll to our story"><FaChevronDown aria-hidden="true" /></a>
      </header>

      {/* STORY */}
      <section id="ab-story" className="tcc-section ab-story reveal" aria-labelledby="ab-story-h" style={{ scrollMarginTop: '80px' }}>
        <div className="tcc-container ab-story__grid">
          <div className="ab-story__media">
            <img src={storyImg} alt="Members of The City Church community together" loading="lazy" />
          </div>
          <div className="ab-story__text">
            <p className="tcc-eyebrow">Who we are</p>
            <h2 className="tcc-h2" id="ab-story-h">Rooted in Luzira. Reaching Uganda.</h2>
            <p>
              The City Church is a vibrant Christian community that has been a source
              of hope, spiritual growth and transformation in Luzira, Kampala for
              many years. Under the leadership of Pastors Alex and Faith Mutagubya,
              the church has grown into a thriving congregation that impacts lives and
              communities.
            </p>
            <p>
              With campuses across Uganda, including Iganga and Kirinya, we are
              committed to spreading the love of Christ and serving our community.
              Our mission is to disciple individuals, plant life giving churches,
              and catalyse spiritual renewal.
            </p>
          </div>
        </div>
      </section>

      {/* FOUNDATION: vision & mission */}
      <section className="tcc-section tcc-section--surface2 ab-foundation reveal" aria-labelledby="ab-found-h">
        <div className="tcc-container">
          <div className="ab-head">
            <p className="tcc-eyebrow">Our foundation</p>
            <h2 className="tcc-h2" id="ab-found-h">What Drives Everything We Do</h2>
          </div>
          <div className="ab-found__grid">
            <article className="ab-statement ab-statement--vision">
              <span className="ab-statement__watermark" aria-hidden="true">VISION</span>
              <div className="ab-statement__header">
                <div className="ab-statement__icon-wrap">
                  <FaEye aria-hidden="true" className="ab-statement__icon" />
                </div>
                <div className="ab-statement__badge">
                  <span className="ab-statement__badge-dot" aria-hidden="true" />
                  <span>Our Vision</span>
                </div>
              </div>
              <p className="ab-statement__text">
                To be a city church influencing our city, our country, our continent,
                and the whole world in Jesus’ name.
              </p>
              <div className="ab-statement__footer">
                <span className="ab-statement__scope-label">Impact Scope</span>
                <div className="ab-statement__tags">
                  <span className="ab-statement__tag">Our City</span>
                  <span className="ab-statement__tag">Our Country</span>
                  <span className="ab-statement__tag">Our Continent</span>
                  <span className="ab-statement__tag">The Whole World</span>
                </div>
              </div>
            </article>

            <article className="ab-statement ab-statement--mission">
              <span className="ab-statement__watermark" aria-hidden="true">MISSION</span>
              <div className="ab-statement__header">
                <div className="ab-statement__icon-wrap">
                  <FaBullseye aria-hidden="true" className="ab-statement__icon" />
                </div>
                <div className="ab-statement__badge">
                  <span className="ab-statement__badge-dot" aria-hidden="true" />
                  <span>Our Mission</span>
                </div>
              </div>
              <p className="ab-statement__text">
                To disciple and empower people for transformation in Jesus’ name.
              </p>
              <div className="ab-statement__footer">
                <span className="ab-statement__scope-label">Core Mandate</span>
                <div className="ab-statement__tags">
                  <span className="ab-statement__tag">Discipleship</span>
                  <span className="ab-statement__tag">Empowerment</span>
                  <span className="ab-statement__tag">Transformation</span>
                </div>
              </div>
            </article>
          </div>
        </div>
      </section>

      {/* VALUES */}
      <section className="tcc-section ab-values reveal" aria-labelledby="ab-values-h">
        <div className="tcc-container">
          <div className="ab-head">
            <p className="tcc-eyebrow">What we live by</p>
            <h2 className="tcc-h2" id="ab-values-h">Our Core Values</h2>
            <p className="tcc-lead">
              Five foundational convictions — <strong>STEPP</strong> — that define our character, shape our culture and guide our church family.
            </p>
          </div>

          <div className="ab-values__stepp-strip" aria-label="Core Values Acronym STEPP">
            <span className="ab-values__stepp-pill"><span className="ab-values__stepp-char">S</span>onship</span>
            <span className="ab-values__stepp-dot" aria-hidden="true">·</span>
            <span className="ab-values__stepp-pill"><span className="ab-values__stepp-char">T</span>eamwork</span>
            <span className="ab-values__stepp-dot" aria-hidden="true">·</span>
            <span className="ab-values__stepp-pill"><span className="ab-values__stepp-char">E</span>xcellence</span>
            <span className="ab-values__stepp-dot" aria-hidden="true">·</span>
            <span className="ab-values__stepp-pill"><span className="ab-values__stepp-char">P</span>rayer</span>
            <span className="ab-values__stepp-dot" aria-hidden="true">·</span>
            <span className="ab-values__stepp-pill"><span className="ab-values__stepp-char">P</span>unctuality</span>
          </div>

          <ul className="ab-values__grid">
            {VALUES.map((v, idx) => (
              <li className="ab-value" key={`${v.title}-${idx}`}>
                <div className="ab-value__top">
                  <span className="ab-value__letter" aria-label={`Letter ${v.letter}`}>{v.letter}</span>
                  <span className="ab-value__icon">{v.icon}</span>
                </div>
                <h3 className="ab-value__title">{v.title}</h3>
                <p className="ab-value__desc">{v.desc}</p>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* JOURNEY: strategy */}
      <section className="ab-journey reveal" aria-labelledby="ab-journey-h">
        <div className="tcc-container">
          <div className="ab-head ab-head--dark">
            <p className="tcc-eyebrow ab-journey__eyebrow">Our strategy</p>
            <h2 className="tcc-h2 ab-journey__title" id="ab-journey-h">Your Journey With Us</h2>
            <p className="ab-journey__lead">
              “A place where you come, feel welcome, stay and keep growing, and then go and reach out.”
            </p>
          </div>
          <ol className="ab-journey__steps">
            {JOURNEY.map((s) => (
              <li className="ab-step" key={s.n}>
                <span className="ab-step__n">{s.n}</span>
                <h3 className="ab-step__title">{s.title}</h3>
                <p className="ab-step__desc">{s.desc}</p>
              </li>
            ))}
          </ol>
        </div>
      </section>

      {/* LEADERSHIP */}
      <section className="tcc-section ab-team reveal" aria-labelledby="ab-lead-h">
        <div className="tcc-container">
          <div className="ab-head">
            <p className="tcc-eyebrow">Our people</p>
            <h2 className="tcc-h2" id="ab-lead-h">Meet Our Leadership</h2>
            <p className="tcc-lead">A dedicated team of pastors passionate about serving God and our community.</p>
          </div>
          <ul className="ab-team__grid">
            {LEADERSHIP.map((p) => (
              <li className="ab-person tcc-card tcc-card--hover" key={p.name}>
                <div className="ab-person__media"><img src={p.avatar} alt={p.name} loading="lazy" /></div>
                <div className="ab-person__body">
                  <h3 className="ab-person__name">{p.name}</h3>
                  <p className="ab-person__title">{p.title}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* ELDERS */}
      <section className="tcc-section tcc-section--surface2 ab-elders reveal" aria-labelledby="ab-eld-h">
        <div className="tcc-container">
          <div className="ab-head">
            <p className="tcc-eyebrow">Spiritual oversight</p>
            <h2 className="tcc-h2" id="ab-eld-h">Our Elders</h2>
            <p className="tcc-lead">Wise and dedicated elders who provide guidance and spiritual covering.</p>
          </div>
          <ul className="ab-elders__grid">
            {ELDERS.map((e) => (
              <li className="ab-person tcc-card tcc-card--hover" key={e.name}>
                <div className="ab-person__media"><img src={e.avatar} alt={e.name} loading="lazy" /></div>
                <div className="ab-person__body">
                  <h3 className="ab-person__name">{e.name}</h3>
                  <p className="ab-person__title">Church Elder</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* MINISTRIES */}
      <section className="tcc-section ab-ministries reveal" aria-labelledby="ab-min-h">
        <div className="tcc-container">
          <div className="ab-head">
            <p className="tcc-eyebrow">Serving together</p>
            <h2 className="tcc-h2" id="ab-min-h">Our Ministries</h2>
            <p className="tcc-lead">Teams caring for the spiritual, social and economic needs of our community.</p>
          </div>
          <ul className="ab-min__grid">
            {MINISTRIES.map((m) => (
              <li className="ab-min tcc-card tcc-card--hover" key={m.name}>
                <div className="ab-min__header">
                  <span className="ab-min__icon">{m.icon}</span>
                  <span className="ab-min__badge">Ministry</span>
                </div>
                <div className="ab-min__body">
                  <h3 className="ab-min__name">{m.name}</h3>
                  <p className="ab-min__head">Led by {m.head}</p>
                  <p className="ab-min__desc">{m.description}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </section>

      {/* VISIT */}
      <section className="tcc-section tcc-section--surface2 ab-visit reveal" aria-labelledby="ab-visit-h">
        <div className="tcc-container ab-visit__grid">
          <div className="ab-visit__text">
            <p className="tcc-eyebrow">Come visit</p>
            <h2 className="tcc-h2" id="ab-visit-h">You’re Always Welcome</h2>
            <p className="ab-visit__lead">
              Our main church is located in Luzira, Kampala. We’d love to meet you in
              person. Plan your first visit and we’ll help you feel right at home.
            </p>
            <p className="ab-visit__addr"><FaMapMarkerAlt aria-hidden="true" /> Main Church, Kitintale, Luzira, Kampala, Uganda</p>
            <div className="ab-visit__actions">
              <Link to="/join-mc" className="tcc-btn tcc-btn--accent tcc-btn--lg">Plan Your Visit <FaArrowRight aria-hidden="true" /></Link>
              <Link to="/contact-us" className="tcc-btn tcc-btn--ghost tcc-btn--lg">Contact Us</Link>
            </div>
          </div>
          <div className="ab-visit__map">
            <iframe
              title="The City Church Luzira location"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3989.751911688117!2d32.6348!3d0.3148!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x177dbb9f6751756d%3A0x5b33f8f86751756d!2sThe%20City%20Church%20Luzira!5e0!3m2!1sen!2sug!4v1678886050000!5m2!1sen!2sug"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default AboutUs;
